// extracted by mini-css-extract-plugin
module.exports = {"audit":"audit--A32lc","btns":"btns--1C4lI","saveBtn":"saveBtn--28Saj","boxTitle":"boxTitle--3WTQk","info":"info--1DxTd","high":"high--2JKwF","editor":"editor--cnfYs"};